/* ============================================================
   CLICK2BUY — Desktop empty-focus search panel v2
   Scope: custom desktop search only.
   Does not patch or replace Shopify's predictive-search.js.

   Purpose:
   - Keep the same empty-focus UX.
   - Do not render recommendation text/products in the initial HTML.
   - Build the panel only after user interaction.
   ============================================================ */

(function () {
  var DESKTOP_SEARCH_SELECTOR = '.c2b-header-search-desktop predictive-search[data-c2b-desktop-search]';
  var ENHANCED_ATTR = 'data-c2b-enhanced';
  var HAS_QUERY_ATTR = 'data-c2b-has-query';
  var EMPTY_PANEL_ATTR = 'data-c2b-empty-focus-panel';
  var CONFIG_SELECTOR = '[data-c2b-empty-focus-config]';
  var PRODUCT_LIMIT = 6;

  function getQuery(input) {
    return input && input.value ? input.value.trim() : '';
  }

  function setHasQueryState(predictiveSearch, input) {
    if (getQuery(input).length > 0) {
      predictiveSearch.setAttribute(HAS_QUERY_ATTR, 'true');
    } else {
      predictiveSearch.removeAttribute(HAS_QUERY_ATTR);
    }
  }

  function getResultsContainer(predictiveSearch) {
    return predictiveSearch.querySelector('[data-predictive-search]');
  }

  function getConfig(predictiveSearch) {
    var config = predictiveSearch.querySelector(CONFIG_SELECTOR);

    if (!config) {
      return {
        searchUrl: '/search',
        termsHeading: 'Se caută',
        productsHeading: 'Produse recomandate',
        terms: [],
        collectionUrl: '',
        productsLimit: PRODUCT_LIMIT,
      };
    }

    var rawTerms = config.getAttribute('data-c2b-empty-focus-terms') || '';
    var terms = rawTerms
      .split(',')
      .map(function (term) {
        return term.trim();
      })
      .filter(Boolean);

    return {
      searchUrl: config.getAttribute('data-c2b-empty-focus-search-url') || '/search',
      termsHeading: config.getAttribute('data-c2b-empty-focus-terms-heading') || 'Se caută',
      productsHeading: config.getAttribute('data-c2b-empty-focus-products-heading') || 'Produse recomandate',
      terms: terms,
      collectionUrl: config.getAttribute('data-c2b-empty-focus-collection-url') || '',
      productsLimit: parseInt(config.getAttribute('data-c2b-empty-focus-products-limit') || PRODUCT_LIMIT, 10),
    };
  }

  function setStatusText(predictiveSearch) {
    var statusElement = predictiveSearch.querySelector('.predictive-search-status');
    var countElement = predictiveSearch.querySelector('[data-predictive-search-live-region-count-value]');

    if (!statusElement || !countElement) return;

    statusElement.setAttribute('aria-hidden', 'false');
    statusElement.textContent = countElement.textContent.trim();

    window.setTimeout(function () {
      statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function createSearchUrl(baseUrl, term) {
    var url;

    try {
      url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('options[prefix]', 'last');
      return url.pathname + url.search;
    } catch (error) {
      return baseUrl + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
    }
  }

  function createIcon() {
    var icon = document.createElement('span');
    icon.className = 'c2b-empty-focus-panel__term-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="6.25" stroke="currentColor" stroke-width="1.35"/><path d="M13.6 13.6L17 17" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"/></svg>';
    return icon;
  }

  function createTermItem(term, index, searchUrl) {
    var item = createElement('li', 'c2b-empty-focus-panel__option');
    item.id = 'C2B-Empty-Focus-Term-' + index;
    item.setAttribute('role', 'option');
    item.setAttribute('aria-selected', 'false');

    var link = document.createElement('a');
    link.href = createSearchUrl(searchUrl, term);
    link.className = 'predictive-search__item c2b-empty-focus-panel__term link link--text';
    link.tabIndex = -1;

    var text = createElement('span', 'c2b-empty-focus-panel__term-text', term);

    link.appendChild(createIcon());
    link.appendChild(text);
    item.appendChild(link);

    return item;
  }

  function createProductItem(product, index) {
    var item = createElement('li', 'c2b-empty-focus-panel__option');
    item.id = 'C2B-Empty-Focus-Product-' + index;
    item.setAttribute('role', 'option');
    item.setAttribute('aria-selected', 'false');

    var link = document.createElement('a');
    link.href = product.url;
    link.className = 'predictive-search__item c2b-empty-focus-panel__product link link--text';
    link.tabIndex = -1;

    if (product.image) {
      var image = document.createElement('img');
      image.className = 'predictive-search__image c2b-empty-focus-panel__product-image';
      image.src = product.image;
      image.alt = product.imageAlt || product.title || '';
      image.width = 48;
      image.height = 48;
      image.loading = 'lazy';
      link.appendChild(image);
    }

    var content = createElement('span', 'c2b-empty-focus-panel__product-content');

    if (product.vendor) {
      content.appendChild(createElement('span', 'predictive-search__item-vendor c2b-empty-focus-panel__product-vendor', product.vendor));
    }

    content.appendChild(createElement('span', 'predictive-search__item-heading c2b-empty-focus-panel__product-title', product.title || ''));

    if (product.price) {
      content.appendChild(createElement('span', 'predictive-search__item-price c2b-empty-focus-panel__product-price', product.price));
    }

    link.appendChild(content);
    item.appendChild(link);

    return item;
  }

  function createGroup(headingId, headingText, listId, items) {
    var group = createElement('div', 'predictive-search__result-group c2b-empty-focus-panel__group');
    var heading = createElement('h2', 'predictive-search__heading c2b-empty-focus-panel__heading', headingText);
    var list = createElement('ul', 'predictive-search__results-list c2b-empty-focus-panel__list list-unstyled');

    heading.id = headingId;
    list.id = listId;
    list.setAttribute('role', 'group');
    list.setAttribute('aria-labelledby', headingId);

    items.forEach(function (item) {
      list.appendChild(item);
    });

    group.appendChild(heading);
    group.appendChild(list);

    return group;
  }

  function buildPanel(config, products) {
    var panel = createElement('div', 'c2b-empty-focus-panel');
    var groups = createElement('div', 'predictive-search__results-groups-wrapper c2b-empty-focus-panel__groups');
    var groupCount = 0;
    var itemCount = 0;

    panel.id = 'predictive-search-results';
    panel.setAttribute('role', 'listbox');

    if (config.terms.length) {
      var termItems = config.terms.map(function (term, index) {
        return createTermItem(term, index + 1, config.searchUrl);
      });

      itemCount += termItems.length;
      groupCount += 1;
      groups.appendChild(createGroup('C2B-Empty-Focus-Terms-Heading', config.termsHeading, 'C2B-Empty-Focus-Terms-List', termItems));
    }

    if (products && products.length) {
      var productItems = products.map(function (product, index) {
        return createProductItem(product, index + 1);
      });

      itemCount += productItems.length;
      groupCount += 1;
      groups.appendChild(
        createGroup('C2B-Empty-Focus-Products-Heading', config.productsHeading, 'C2B-Empty-Focus-Products-List', productItems)
      );
    }

    if (!itemCount) return null;

    if (groupCount === 1) {
      groups.classList.add('c2b-empty-focus-panel__groups--single');
    }

    var count = createElement('span', 'hidden', itemCount + ' rezultate');
    count.setAttribute('data-predictive-search-live-region-count-value', '');

    panel.appendChild(groups);
    panel.appendChild(count);

    return panel;
  }

  function getImageUrl(image) {
    if (!image) return '';
    if (image.getAttribute('src')) return image.getAttribute('src');

    var srcset = image.getAttribute('srcset');
    if (!srcset) return '';

    return srcset.split(',')[0].trim().split(' ')[0];
  }

  function normalizeProductUrl(href) {
    if (!href) return '';

    try {
      var url = new URL(href, window.location.origin);
      return url.pathname + url.search;
    } catch (error) {
      return href;
    }
  }

  function cleanText(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function parseProductsFromCollectionHtml(html, limit) {
    var documentFragment = new DOMParser().parseFromString(html, 'text/html');
    var items = Array.prototype.slice.call(documentFragment.querySelectorAll('#product-grid > li, #product-grid .grid__item'));
    var products = [];

    items.some(function (item) {
      if (products.length >= limit) return true;

      var link = item.querySelector('.card__heading a[href*="/products/"], a.full-unstyled-link[href*="/products/"], a[href*="/products/"]');
      if (!link) return false;

      var image = item.querySelector('.card__media img, .media img, img');
      var vendor = item.querySelector('.caption-with-letter-spacing, .card__vendor, [data-c2b-card-vendor]');
      var price = item.querySelector('.price .price-item--sale, .price .price-item--regular, .price__container, .price');
      var title = cleanText(link);

      if (!title) return false;

      products.push({
        url: normalizeProductUrl(link.getAttribute('href')),
        title: title,
        vendor: cleanText(vendor),
        price: cleanText(price),
        image: getImageUrl(image),
        imageAlt: image ? image.getAttribute('alt') || title : title,
      });

      return false;
    });

    return products;
  }

  function fetchRecommendedProducts(predictiveSearch, config) {
    if (!config.collectionUrl) return Promise.resolve([]);
    if (predictiveSearch.c2bEmptyFocusProductsCache) return Promise.resolve(predictiveSearch.c2bEmptyFocusProductsCache);
    if (predictiveSearch.c2bEmptyFocusProductsPromise) return predictiveSearch.c2bEmptyFocusProductsPromise;

    var collectionUrl = config.collectionUrl;
    predictiveSearch.c2bEmptyFocusProductsPromise = fetch(collectionUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
      },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load collection products.');
        return response.text();
      })
      .then(function (html) {
        var products = parseProductsFromCollectionHtml(html, config.productsLimit || PRODUCT_LIMIT);
        predictiveSearch.c2bEmptyFocusProductsCache = products;
        return products;
      })
      .catch(function () {
        predictiveSearch.c2bEmptyFocusProductsCache = [];
        return [];
      });

    return predictiveSearch.c2bEmptyFocusProductsPromise;
  }

  function renderPanel(predictiveSearch, config, products) {
    var resultsContainer = getResultsContainer(predictiveSearch);
    var panel = buildPanel(config, products);

    if (!resultsContainer || !panel) return false;

    resultsContainer.innerHTML = '';
    resultsContainer.appendChild(panel);
    return true;
  }

  function setOpenState(predictiveSearch, input) {
    var resultsContainer = getResultsContainer(predictiveSearch);

    if (resultsContainer) {
      var header = document.querySelector('.section-header');
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      resultsContainer.style.maxHeight = window.innerHeight - headerBottom + 'px';
    }

    predictiveSearch.setAttribute('results', 'true');
    predictiveSearch.setAttribute('open', 'true');
    predictiveSearch.setAttribute(EMPTY_PANEL_ATTR, 'true');
    predictiveSearch.removeAttribute('loading');
    input.setAttribute('aria-expanded', 'true');
    predictiveSearch.isOpen = true;

    setStatusText(predictiveSearch);
  }

  function closeEmptyPanel(predictiveSearch, input) {
    if (!predictiveSearch.hasAttribute(EMPTY_PANEL_ATTR)) return;

    var resultsContainer = getResultsContainer(predictiveSearch);
    var selected = predictiveSearch.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', 'false');

    predictiveSearch.removeAttribute(EMPTY_PANEL_ATTR);
    predictiveSearch.removeAttribute('results');
    predictiveSearch.removeAttribute('open');
    predictiveSearch.removeAttribute('loading');
    predictiveSearch.isOpen = false;

    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-activedescendant', '');
    }

    if (resultsContainer) {
      resultsContainer.removeAttribute('style');
      resultsContainer.innerHTML = '';
    }
  }

  function openEmptyPanel(predictiveSearch, input) {
    if (!predictiveSearch || !input || getQuery(input).length > 0) return;

    var config = getConfig(predictiveSearch);
    var requestId = String(Date.now()) + Math.random().toString(16).slice(2);

    predictiveSearch.c2bEmptyFocusRequestId = requestId;

    if (renderPanel(predictiveSearch, config, predictiveSearch.c2bEmptyFocusProductsCache || [])) {
      setOpenState(predictiveSearch, input);
    }

    fetchRecommendedProducts(predictiveSearch, config).then(function (products) {
      if (predictiveSearch.c2bEmptyFocusRequestId !== requestId) return;
      if (getQuery(input).length > 0) return;

      if (renderPanel(predictiveSearch, config, products)) {
        setOpenState(predictiveSearch, input);
      }
    });
  }

  function handleEmptyPanelKeyboard(event, predictiveSearch, input) {
    if (!predictiveSearch.hasAttribute(EMPTY_PANEL_ATTR)) return;
    if (getQuery(input).length > 0) return;

    if (event.code === 'ArrowUp') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof predictiveSearch.switchOption === 'function') predictiveSearch.switchOption('up');
      return;
    }

    if (event.code === 'ArrowDown') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof predictiveSearch.switchOption === 'function') predictiveSearch.switchOption('down');
      return;
    }

    if (event.code === 'Enter') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof predictiveSearch.selectOption === 'function') predictiveSearch.selectOption();
      return;
    }

    if (event.code === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeEmptyPanel(predictiveSearch, input);
    }
  }

  function enhancePredictiveSearch(predictiveSearch) {
    if (!predictiveSearch || predictiveSearch.getAttribute(ENHANCED_ATTR) === 'true') return;

    var input = predictiveSearch.querySelector('input[type="search"]');
    if (!input) return;

    predictiveSearch.setAttribute(ENHANCED_ATTR, 'true');
    setHasQueryState(predictiveSearch, input);

    input.addEventListener('input', function () {
      setHasQueryState(predictiveSearch, input);

      if (getQuery(input).length > 0) {
        predictiveSearch.c2bEmptyFocusRequestId = '';
        closeEmptyPanel(predictiveSearch, input);
      }
    });

    input.addEventListener('focus', function () {
      setHasQueryState(predictiveSearch, input);
      openEmptyPanel(predictiveSearch, input);
    });

    if (input.form) {
      input.form.addEventListener('reset', function () {
        window.requestAnimationFrame(function () {
          setHasQueryState(predictiveSearch, input);

          if (document.activeElement === input) {
            openEmptyPanel(predictiveSearch, input);
          }
        });
      });
    }

    predictiveSearch.addEventListener(
      'keyup',
      function (event) {
        handleEmptyPanelKeyboard(event, predictiveSearch, input);
      },
      true
    );

    predictiveSearch.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!predictiveSearch.contains(document.activeElement)) {
          predictiveSearch.c2bEmptyFocusRequestId = '';
          closeEmptyPanel(predictiveSearch, input);
        }
      });
    });
  }

  function initDesktopHeaderSearch() {
    document.querySelectorAll(DESKTOP_SEARCH_SELECTOR).forEach(enhancePredictiveSearch);
  }

  function boot() {
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements
        .whenDefined('predictive-search')
        .then(initDesktopHeaderSearch)
        .catch(initDesktopHeaderSearch);
      return;
    }

    initDesktopHeaderSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
